<script setup lang="ts">

import {useCheckoutStore} from "@/checkout/stores/checkout.store.ts";
import CheckoutHeader from "@/checkout/components/CheckoutHeader.vue";
import CheckoutSummary from "@/checkout/components/CheckoutSummary.vue";
import CheckoutForm from "@/checkout/components/CheckoutForm.vue";

interface Props {
  checkoutId: string
}

const props = defineProps<Props>()
const checkout = useCheckoutStore();
checkout.init(props.checkoutId.toString())

</script>

<template>
  <div class="bg-white">
    <!-- Background color split screen for large screens -->
    <div class="fixed left-0 top-0 hidden h-full w-1/2 bg-white lg:block" aria-hidden="true"></div>
    <div class="fixed right-0 top-0 hidden h-full w-1/2 bg-gray-50 lg:block" aria-hidden="true"></div>

    <CheckoutHeader :step="2">
      <a v-if="checkout.loading && checkout.config" :href="checkout.config.basketReturn.url" class="text-slate-500 hover:text-gray-900"
         :title="checkout.config.basketReturn.label">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="h-8 w-8 fill-primary hover:fill-primary/80">
          <path
              d="M0 24C0 10.7 10.7 0 24 0L69.5 0C91.6 0 111 12.8 120.1 32l411 0c26.3 0 45.5 25 38.6 50.4L538.8 197.2c-13.7-3.4-28-5.2-42.8-5.2c-1.8 0-3.7 0-5.5 .1L520.7 80 131.1 80l30.5 160 213.6 0c-14.6 13.8-26.8 30-36 48l-168.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5l123.2 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16l-121 0c-34.5 0-64.2-24.5-70.7-58.5L77.4 54.5c-.8-3.8-4.1-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM134.4 440c8.6-14.9 24.4-24 41.6-24s33 9.1 41.6 24s8.6 33.1 0 48s-24.4 24-41.6 24s-33-9.1-41.6-24s-8.6-33.1 0-48zM371.3 296c25.7-44.6 73.3-72 124.7-72s99 27.4 124.7 72s25.7 99.4 0 144S547.4 512 496 512s-99-27.4-124.7-72s-25.7-99.4 0-144zm49.4 60.7c-6.3 6.2-6.3 16.4 0 22.6c18.7 18.7 37.3 37.3 56 56c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L470.6 384l89.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-89.4 0 28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56 56z"/>
        </svg>
      </a>
    </CheckoutHeader>

    <main v-if="!checkout.loading" class="relative mx-auto grid max-w-7xl grid-cols-1 gap-x-16 lg:grid-cols-2 lg:px-8 xl:gap-x-48">
      <CheckoutForm/>
      <CheckoutSummary/>
    </main>
  </div>
</template>

<style scoped>

</style>